exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filters[data-v-5532a424] {\n\tmargin-bottom: 16px;\n}\n.filters-form[data-v-5532a424] {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\t-webkit-box-pack: justify;\n\t    -ms-flex-pack: justify;\n\t        justify-content: space-between;\n\twidth: 100%;\n}\n.filters-actions[data-v-5532a424] {\n\tmargin-left: auto;\n}\n.reference-data-grid[data-v-5532a424] {\n\theight: calc(100vh - 280px);\n}\n", ""]);

// exports
